import Cast from 'scratch-vm/src/util/cast';

class CIPDcMotor01Block {
    constructor() {

    }

    async dcMotorControl(dcMotor01, arg) {
        if (!dcMotor01) {
            return {
                result: false,
                error: '[Error] The dc motor 01 is not connected.',
            };
        }

        if (dcMotor01?.dcMotorControl) {
            dcMotor01.dcMotorControl(arg);
        }

        return new Promise(resolve => setTimeout(() => {
            resolve({
                result: true,
                error: null
            });
        }, 50)); // 0.05초 대기
    }

    async dcMotorWithTimeControl(dcMotor01, arg, second) {
        if (!dcMotor01) {
            return {
                result: false,
                error: '[Error] The dc motor 01 is not connected.',
            };
        }

        if (dcMotor01?.dcMotorControl) {
            dcMotor01.dcMotorControl(arg);
        }

        const sec = Cast.toNumber(second) * 1000;

        return new Promise(resolve => {
            setTimeout(() => {
                dcMotor01.dcMotorControl('Stop');
            }, sec);
            setTimeout(() => {
                resolve({
                    result: true,
                    error: null
                });
            }, sec + 50);
        }); // 0.05초 대기
    }
}

export default CIPDcMotor01Block;
